/* eslint "react/prop-types": "warn" */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

import SegmentSidebar from './SegmentSidebar.jsx';
import SidebarLayout from 'platopulse/components/SidebarLayout.jsx';
import SegmentDetail from "platopulse/reference/segments/SegmentDetail.jsx"

import * as metadataActions from 'platopulse/redux/metadata';
import * as actions from 'platopulse/reference/reference';

import {
    getUser,
    getSegment,
    getSegmentId,
    getDatabaseId,
    getIsEditing
} from '../selectors';

const mapStateToProps = (state, props) => ({
    user: getUser(state, props),
    segment: getSegment(state, props),
    segmentId: getSegmentId(state, props),
    databaseId: getDatabaseId(state, props),
    isEditing: getIsEditing(state, props)
});

const mapDispatchToProps = {
    ...metadataActions,
    ...actions
};

@connect(mapStateToProps, mapDispatchToProps)
export default class SegmentDetailContainer extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        databaseId: PropTypes.number.isRequired,
        user: PropTypes.object.isRequired,
        segment: PropTypes.object.isRequired,
        segmentId: PropTypes.number.isRequired,
        isEditing: PropTypes.bool
    };

    async fetchContainerData(){
        await actions.wrappedFetchSegmentDetail(this.props, this.props.segmentId);
    }

    componentWillMount() {
        this.fetchContainerData()
    }


    componentWillReceiveProps(newProps) {
        if (this.props.location.pathname === newProps.location.pathname) {
            return;
        }

        actions.clearState(newProps)
    }

    render() {
        const {
            user,
            segment,
            isEditing
        } = this.props;

        return (
            <SidebarLayout
                className="flex-full relative"
                style={ isEditing ? { paddingTop: '43px' } : {}}
                sidebar={<SegmentSidebar segment={segment} user={user}/>}
            >
                <SegmentDetail {...this.props} />
            </SidebarLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./reference/segments/SegmentDetailContainer.jsx